import React, { Component } from 'react';
import { Col, Card, CardHeader, CardBody, Row } from 'reactstrap';
import update from '../../assets/fontawesome/update_big.png'
import Helmet from 'react-helmet'
import './index.css'
import Mailchimp from '../../components/mailchimpForm';
import SignupForm from '../../components/signup';
import Cookies from 'js-cookie';
import iconOne from '../../assets/img/join/icon-1.png';
import iconSec from '../../assets/img/join/icon-2.png';
import searchIcon from '../../assets/img/join/searchIcon.png';
import iconThrd from '../../assets/img/join/icon-3.png';
import iconFrth from '../../assets/img/join/icon-4.png';
import iconFifth from '../../assets/img/join/icon-5.png';

class Updates extends Component {

  constructor() {
    super();

    if (Cookies.get('token') || Cookies.get('accessToken')) {
      window.location = '/'
    }
  }

  render() {
    return (
      <div className="animated fadeIn" style={{ height: '100%' }}>
        <Helmet>
          <title>Growjo - Join</title>
          <meta name="description" content="Growjo: Update" />
          <meta name="author" content="Growjo"></meta>
        </Helmet>
        <Card className='modifyCard' style={{ height: '100%' }}>
          {/* <CardHeader style={{ backgroundColor: 'white', color: '#1c1d38' }}><img src={update} style={{ float: 'left', marginRight: 13, marginTop: 4 }} /><h1 style={{ color: '#474866', fontSize: 22, marginBottom: 0 }}>Why Subscribe?</h1></CardHeader> */}
          <CardBody className='pb-5'>
            <Row>
              <Col className='d-flex justify-content-start align-items-start flex-column order-2 order-sm-1' xs={12} md={6}>
                <Row className='pt-4'>
                  <div className='d-flex justify-content-center align-items-center' style={{ width: 100 }}>
                    <img src={iconOne} />
                  </div>
                  <Col className='w-100 col d-flex justify-content-start align-items-start flex-column col'>
                    <h3 style={{ color: '#000 ', margin: 0, fontSize: 24 }}>It’s Free!</h3>
                    <p style={{ color: '#8083A3', margin: 0, fontSize: 16 }}>Currently there is no cost to join Growjo.</p>
                  </Col>
                </Row>
                <Row className='pt-4'>
                  <div className='d-flex justify-content-center align-items-center' style={{ width: 100 }}>
                    <img src={iconSec} />
                  </div>
                  <Col className='w-100 col d-flex justify-content-start align-items-start flex-column col'>
                    <h3 style={{ color: '#000 ', margin: 0, fontSize: 24 }}>Export 1,000 Companies per month free.</h3>
                    <p style={{ color: '#8083A3', margin: 0, fontSize: 16 }}>Get CSV exports for you to use personally.</p>
                  </Col>
                </Row>
                <Row className='pt-4'>
                  <div className='d-flex justify-content-center align-items-center' style={{ width: 100 }}>
                    <img src={searchIcon} />
                  </div>
                  <Col className='w-100 col d-flex justify-content-start align-items-start flex-column col'>
                    <h3 style={{ color: '#000 ', margin: 0, fontSize: 24 }}>Unlimited Verified Emails and Contacts </h3>
                    <p style={{ color: '#8083A3', margin: 0, fontSize: 16 }}>Export more if you upload your contacts.</p>
                  </Col>
                </Row>
                {/* <Row className='pt-4'>
                  <div className='d-flex justify-content-center align-items-center' style={{ width: 100 }}>
                    <img src={iconThrd} />
                  </div>
                  <Col className='w-100 col d-flex justify-content-start align-items-start flex-column col'>
                    <h3 style={{ color: '#000 ', margin: 0, fontSize: 24 }}>Claim your company’s profile*</h3>
                    <p style={{ color: '#8083A3', margin: 0, fontSize: 16 }}>Signup with your work email and you can edit your company’s data.</p>
                  </Col>
                </Row> */}
                <Row className='pt-4'>
                  <div className='d-flex justify-content-center align-items-center' style={{ width: 100 }}>
                    <img src={iconFrth} />
                  </div>
                  <Col className='w-100 col d-flex justify-content-start align-items-start flex-column col'>
                    <h3 style={{ color: '#000 ', margin: 0, fontSize: 24 }}>Funding News and Valuations</h3>
                    <p style={{ color: '#8083A3', margin: 0, fontSize: 16 }}>Get daily news of fundings and valuation data.</p>
                  </Col>
                </Row>
                <Row className='pt-4'>
                  <div className='d-flex justify-content-center align-items-center' style={{ width: 100 }}>
                    <img src={iconFifth} />
                  </div>
                  <Col className='w-100 col d-flex justify-content-start align-items-start flex-column col'>
                    <h3 style={{ color: '#000 ', margin: 0, fontSize: 24 }}>Employee Growth Updates & Revenue</h3>
                    <p style={{ color: '#8083A3', margin: 0, fontSize: 16 }}>Stay on top of which startups are growing the fastest.</p>
                  </Col>
                </Row>
                {/* <div style={{ lineHeight: '40px' }}>
                  <div style={{ height: 15, width: 15, backgroundColor: '#faa21b', borderRadius: '50%', float: 'left', marginTop: 14 }} />
                  <h4 style={{ color: '#29658a ', margin: 0, marginLeft: 30, lineHeight: '44px', fontSize: 16 }}>
                    Join Growjo and get the 10,000 list for free
                </h4>
                </div>
                <div style={{ lineHeight: '40px' }}>
                  <div style={{ height: 15, width: 15, backgroundColor: '#faa21b', borderRadius: '50%', float: 'left', marginTop: 14 }} />
                  <h4 style={{ color: '#29658a ', margin: 0, marginLeft: 30, lineHeight: '44px', fontSize: 16 }}>
                    Get Company Competitor and Alternatives Data.
                </h4>
                </div>

                <div style={{ lineHeight: '40px' }}>
                  <div style={{ height: 15, width: 15, backgroundColor: '#faa21b', borderRadius: '50%', float: 'left', marginTop: 14 }} />
                  <h4 style={{ color: '#29658a ', margin: 0, marginLeft: 30, lineHeight: '44px', fontSize: 16 }}>
                    Get the ranking updates every other month
                </h4>
                </div>
                <div style={{ lineHeight: '40px' }}>
                  <div style={{ height: 15, width: 15, backgroundColor: '#faa21b', borderRadius: '50%', float: 'left', marginTop: 14 }} />
                  <h4 style={{ color: '#29658a ', margin: 0, marginLeft: 30, lineHeight: '44px', fontSize: 16 }}>
                    Export the fastest startups metro lists
                </h4>
                </div>
                <div style={{ lineHeight: '40px' }}>
                  <div style={{ height: 15, width: 15, backgroundColor: '#faa21b', borderRadius: '50%', float: 'left', marginTop: 14 }} />
                  <h4 style={{ color: '#29658a ', margin: 0, marginLeft: 30, lineHeight: '44px', fontSize: 16 }}>
                    Learn how to grow your own company revenue
                </h4>
                </div>
                <div style={{ lineHeight: '40px' }}>
                  <div style={{ height: 15, width: 15, backgroundColor: '#faa21b', borderRadius: '50%', float: 'left', marginTop: 14 }} />
                  <h4 style={{ color: '#29658a ', margin: 0, marginLeft: 30, lineHeight: '44px', fontSize: 16 }}>
                    Claim your company's profile*
                </h4>
                </div>
                <div style={{ lineHeight: '40px' }}>
                  <div style={{ height: 15, width: 15, backgroundColor: '#faa21b', borderRadius: '50%', float: 'left', marginTop: 14 }} />
                  <h4 style={{ color: '#29658a ', margin: 0, marginLeft: 30, lineHeight: '44px', fontSize: 16 }}>
                    Annual Revenue and Sales Financials
                </h4>
                </div>
                <div style={{ lineHeight: '40px' }}>
                  <div style={{ height: 15, width: 15, backgroundColor: '#faa21b', borderRadius: '50%', float: 'left', marginTop: 14 }} />
                  <h4 style={{ color: '#29658a ', margin: 0, marginLeft: 30, lineHeight: '44px', fontSize: 16 }}>
                    Number of Employees Growth
                </h4>
                </div> */}
              </Col>
              <Col className='d-flex justify-content-start align-items-start flex-column order-1 order-sm-2' xs={12} md={6}>
                <h1 style={{ color: '#474866', fontSize: 48, fontWeight: 'bold', margin: 0 }}>Subscribe for FREE!</h1>
                <SignupForm className='py-5' />
              </Col>
            </Row>
            <div style={{ bottom: 15, position: 'absolute', color: '#8083A3', fontSize: 14, fontWeight: 'normal' }}>You must have an email address that matches the company to claim a profile.</div>
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default Updates;



// WEBPACK FOOTER //
// ./client/src/views/Join/index.js